import { Box, Flex, Icon } from "@chakra-ui/react";
import { FaWhatsapp } from "react-icons/fa";

export function HomeWhatsappFab() {
  return (
    <Box
      position="fixed"
      bottom="24px"
      right="24px"
      zIndex="999"
      onClick={() => window.open("https://wa.me/5585994176634", "_blank")}
      cursor="pointer"
      _hover={{ transform: "scale(1.08)" }}
      transition="transform 0.2s ease"
      aria-label="Falar no WhatsApp"
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          window.open("https://wa.me/5585994176634", "_blank");
        }
      }}
    >
      <Flex
        align="center"
        justify="center"
        bg="#25D366"
        w="56px"
        h="56px"
        borderRadius="full"
        boxShadow="0 4px 16px rgba(0, 0, 0, 0.2)"
      >
        <Icon as={FaWhatsapp} color="white" boxSize={6} />
      </Flex>
    </Box>
  );
}
